import React from "react";

const Organization = React.lazy(() => import('src/pages/super-admin/organization'))
const HistoryLogs = React.lazy(() => import('src/pages/super-admin/history-logs/index'))
const ArchivedOrganizations = React.lazy(() => import('src/pages/super-admin/archived-organizations'))

const SuperAdminRoutes = [
 {
  sidebar: true,
  sidebarVisible: true,
  parent: true,
  id: 'super-admin',
  sidebarLabel: 'Super Admin Dashboard',
 },
 {
  path: '/super-admin/organization',
  element: <Organization />,
  sidebar: true,
  sidebarVisible: true,
  parentId: 'super-admin',
  sidebarLabel: 'Organizations',
  mainLabel: 'Organizations',
 },
 {
  path: '/super-admin/history-logs',
  element: <HistoryLogs />,
  sidebar: true,
  sidebarVisible: true,
  parentId: 'super-admin',
  sidebarLabel: 'Activity Logs',
  mainLabel: 'History',
 },
 {
  path: '/super-admin/archived-organizations',
  element: <ArchivedOrganizations />,
  sidebar: true,
  sidebarVisible: true,
  parentId: 'super-admin',
  sidebarLabel: 'Archived Organizations',
  mainLabel: 'Archived Organizations',
 },
];

export default SuperAdminRoutes;
